<template>
  <v-btn
    size="small"
    :color="labelColor(status)"
    class="ml-0"
    theme="dark"
    tile
    flat
  >
    {{ statusI18n }}
  </v-btn>
</template>

<script>
import { labelColor } from "../model/labelColor";

export default {
  name: "DaytimeAdviceSheetStatusChip",
  props: {
    status: {
      type: [Number, String],
      required: true
    },
    statusI18n: {
      type: String,
      required: true
    }
  },
  methods: {
    labelColor
  }
};
</script>
